import { render } from "./ProductsList.vue?vue&type=template&id=68c3a810&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=ts"
export * from "./ProductsList.vue?vue&type=script&lang=ts"

import "./ProductsList.vue?vue&type=style&index=0&id=68c3a810&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-68c3a810"

export default script